import { render, staticRenderFns } from "./loginwithAD.vue?vue&type=template&id=328c4a3f&scoped=true"
import script from "./loginwithAD.vue?vue&type=script&lang=js"
export * from "./loginwithAD.vue?vue&type=script&lang=js"
import style0 from "./loginwithAD.vue?vue&type=style&index=0&id=328c4a3f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c4a3f",
  null
  
)

export default component.exports